/**
 * Tenant-Aware Landing Page Router
 * 
 * Shows tenant-specific landing page when ?tenant=<slug> is present
 * Otherwise shows the default Cerebro landing page
 */
import React from 'react';
import { useTenant } from '../contexts/TenantContext';
import LandingPage from './LandingPage';
import OldMutualLanding from './tenant/OldMutualLanding';

// Map tenant slugs to their custom landing pages
const TENANT_LANDING_PAGES = {
  'oldmutual': OldMutualLanding,
  // Add more tenants here as needed:
  // 'acme': AcmeLanding,
};

export default function TenantLandingPage() {
  const { tenant, loading, tenantSlug } = useTenant();
  
  // Show loading state while fetching tenant
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="h-8 w-8 border-2 border-amber-500/30 border-t-amber-500 rounded-full animate-spin" />
      </div>
    );
  }
  
  // Check if this tenant has a custom landing page
  const slug = tenantSlug || tenant?.slug;
  const TenantComponent = slug ? TENANT_LANDING_PAGES[slug.toLowerCase()] : null;
  
  // If tenant has custom landing page, show it
  if (TenantComponent) {
    return <TenantComponent />;
  }
  
  // Otherwise show default Cerebro landing page
  return <LandingPage />;
}
